import { ReactElement } from 'react'
import { Part, ValidationTag } from '../../../Common/interfaces'
import Invalid from './Type/Invalid'
import Duplicate from './Type/Dupiclate'
import { observer } from 'mobx-react-lite'

interface Props {
  validatedParts: Part[]
}

const Messages = observer((props: Props): ReactElement => {
  const { validatedParts } = props

  const duplicateParts = validatedParts?.filter(
    ({ validationTag, visible }) =>
      validationTag === ValidationTag.DUPLICATE && visible
  )

  const invalidParts = validatedParts?.filter(
    ({ validationTag, visible }) =>
      validationTag === ValidationTag.INVALID && visible
  )

  return (
    <>
      {invalidParts?.length > 0 && <Invalid parts={invalidParts} />}
      {duplicateParts?.length > 0 && <Duplicate parts={duplicateParts} />}
    </>
  )
})

export default Messages
